import { Box, Grid, Typography, useTheme } from '@mui/material';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import BackgroundCard from 'ui-component/cards/BackgroundCard';

const CardCryptoPayment = ({
    description,
    step,
    title,
    flexDirection = 'row',
    sizeIcon = 32,
    childrenIcon,
    gap = 2
}: {
    step: number;
    title: string;
    description: string;
    flexDirection?: 'column' | 'row';
    sizeIcon?: number;
    childrenIcon: ReactNode;
    gap?: number;
}) => {
    const theme = useTheme();
    return (
        <BackgroundCard backgroundColorLight={theme.palette.grey[200]} sx={{ height: '100%' }}>
            <Grid container flexDirection={flexDirection} gap={gap}>
                <Grid item>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ backgroundColor: theme.palette.primary.main, borderRadius: 1, height: sizeIcon, width: sizeIcon }}
                    >
                        {childrenIcon}
                    </Box>
                </Grid>
                <Grid item flex={1}>
                    <Typography variant="h5" fontWeight={600}>
                        <FormattedMessage id={title} />
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: theme.palette.grey[500] }}>
                        <FormattedMessage id={description} />
                    </Typography>
                </Grid>
            </Grid>
        </BackgroundCard>
    );
};

export default CardCryptoPayment;
